import { mapperGlobalDataTheme } from '../../../../core/data-layer/global-data/mappers'
import { mapperModuleMedia } from '../../../../core/data-layer/modules/module-media/mapper-module-media'
import { mapperModuleNavigationLink } from '../../../../core/data-layer/modules/module-navigation-link/mapper-module-navigation-link'
import type { MapperOptions } from '#layers/core/types'

export const mapperBlockCampaignsCallOut = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }
  const imageOptions = {
    lazy: true,
    sizes: {
      small: { width: 327, height: 184, aspectRatio: '16/9' },
      medium: { width: 324, height: 432, aspectRatio: '3/4' },
      large: { width: 576, height: 432, aspectRatio: '4/3' }
    }
  }
  return {
    title: data.title || '',
    description: data.description || '',
    id: data.sys?.id || '',
    sys: data.sys || null,
    contentType: data.contentType,
    link: mapperModuleNavigationLink(data.link, options.getUrl),
    image: mapperModuleMedia(data.image, imageOptions),
    orientation: data.orientation || '',
    theme: mapperGlobalDataTheme(data.theme)?.theme || null
  }
}
